import { CommonModule, DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbDropdownModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';
import { ShiftRosterService } from '../../../Model/ShiftRoster/shift-roster.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { elements } from 'chart.js';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-shift-roster',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgbDatepickerModule, NgbDropdownModule, NgSelectModule, DataTablesModule],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './shift-roster.component.html',
  styleUrl: './shift-roster.component.scss'
})
export class ShiftRosterComponent {
  isDisabled: boolean = false;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  Datas = [] as any;
  ExcelDatas = [] as any;
  DisplayColumns = [] as any
  minDate = null as any;
  maxDate = null as any;


  filter = {
    SelectType: 'S',
    EmpMasterId: null,
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    MonthYear: null,
    EmpType: 'front',
    EmpCode: ''
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private dateFormate: CustomDateParserFormatter,
    public datepipe: DatePipe,
    private session: SessionService,
    private toast: ToastService,
    private utility: UtilityService,
    private shiftRoster: ShiftRosterService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private download: DownloadSampleService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    //this.filter.EmpMasterId = this.session.GetUserDetails().UserId;
    this.SelectDate('RegistrationDate', null, null);
    this.ESS_RosterFillComboLoad('BranchLoadOnSiteRights');
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any, isExcel: boolean) {
    if (form.valid) {
      if (this.common.PageRight.IsView) {
        if (moment(this.dateFormate.format(this.filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.filter.FromDateObj), 'DD MMM YYYY'))) {
          if (this.filter.FromDateObj.month == this.filter.ToDateObj.month && this.filter.FromDateObj.year == this.filter.ToDateObj.year) {
            this.ESS_EmpRoster_SelectGet(isExcel);
          } else {
            this.toast.show({ message: 'Please select from date to date in single month year', type: toastTypeEnum.danger });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
        }
      }
    } else {
      form.submitted = true;
    }
  }

  ESS_RosterFillComboLoad(SelectType: string) {
    this.isDisabled = true;
    if (SelectType == 'BranchLoadOnSiteRights') {
      this.filter.BranchId = null;
      this.filter.ClientId = null;
      this.filter.SiteId = null;

      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];
      this.ClearData();
    } else if (SelectType == 'ClientLoadOnBranchRights') {
      this.filter.ClientId = null;
      this.filter.SiteId = null;

      this.Clients = [];
      this.Sites = [];
      this.ClearData();
    } else if (SelectType == 'UserWiseSiteRights') {
      this.filter.SiteId = null;
      this.Sites = [];
      this.ClearData();
    }

    return this.shiftRoster.ESS_RosterFillComboLoad({ 'SelectType': SelectType, 'BranchId': this.filter.BranchId, 'ClientId': this.filter.ClientId, 'SiteId': this.filter.SiteId, 'DesignationId': null }).subscribe({
      next: (response) => {
        if (SelectType == 'BranchLoadOnSiteRights') {
          if (response.Table) {
            this.Branchs = response.Table
          }
        } else if (SelectType == 'ClientLoadOnBranchRights') {
          if (response.Table) {
            this.Clients = response.Table
          }
        } else if (SelectType == 'UserWiseSiteRights') {
          if (response.Table) {
            this.Sites = response.Table
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpRoster_SelectGet(isExcel = false) {
    this.isDisabled = true;
    this.filter.FromDate = this.dateFormate.format(this.filter.FromDateObj);
    this.filter.ToDate = this.dateFormate.format(this.filter.ToDateObj);
    this.filter.ClientId = this.filter.EmpType === 'back' ? null : this.filter.ClientId;
    this.filter.SiteId = this.filter.EmpType === 'back' ? null : this.filter.SiteId;
    this.Datas = [];
    this.DisplayColumns = [];
    return this.shiftRoster.ESS_EmpRoster_SelectGet(this.filter).subscribe({
      next: (response) => {
        if (response.Table) {
          if (isExcel) {
            if (response.Table.length > 0) {
              this.download.exportToExcel(Object.values(response.Table), "ShifRoster", Object.values(response.Table1));
            } else {
              this.toast.show({ message: 'no data found', type: toastTypeEnum.danger });
            }
            this.isDisabled = false;
          } else {
            this.Datas = Object.values(response.Table);
            let isPush = false;
            if (response.Table.length > 0) {
              Object.keys(response.Table[0]).forEach(element => {
                if (this.common.ToLowerCase(element) == 'shiftcode') {
                  isPush = false;
                }
                if (isPush) {
                  this.DisplayColumns.push(element);
                }
                if (this.common.ToLowerCase(element) == 'monthyear') {
                  isPush = true;
                }
              });
            }
          }
        }
        // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //   dtInstance.destroy();
        //   this.dtTrigger.next(null);
        // });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpRoster_InsertUpdate() {
    if (this.common.PageRight.IsAdd) {
      if (this.Datas.filter((e: any) => e.IsModified).length > 0) {
        const modalRef = this.modalService.open(ConfirmationComponent);
        modalRef.componentInstance.Message = 'Do you want to save?';
        modalRef.result.then(result => {
          if (result) {
            this.isDisabled = true;
            this.shiftRoster.ESS_EmpRoster_InsertUpdate({ 'SelectType': 'I', 'MonthYear': this.Datas[0].MonthYear, 'ESS_EmpRosterMaster': this.Datas.filter((e: any) => e.IsModified) }).subscribe({
              next: (response) => {
                if (response.Error_Code == '458' || response.Error_Code == '457') {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.ClearData();
                    }
                  });
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        });
      } else {
        this.toast.show({ message: 'No Data for save', type: toastTypeEnum.warning });
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.filter.FromDateObj = this.dateFormate.parse(response.Table[0].RegistrationDate);
          this.filter.FromDateObj.day = 1;
          this.filter.ToDateObj = this.dateFormate.parse(response.Table[0].RegistrationDate);
          this.filter.ToDateObj.day = new Date(this.filter.ToDateObj.year, this.filter.ToDateObj.month, 0).getDate();

          this.minDate = this.dateFormate.parse(response.Table[0].RegistrationDate);
          this.minDate.day = 1;
          this.maxDate = this.dateFormate.parse(response.Table[0].RegistrationDate);
          this.maxDate.day = new Date(this.filter.ToDateObj.year, this.filter.ToDateObj.month, 0).getDate();

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  handleFileInput(event: any): void {
    this.ExcelDatas = [];
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      if (this.common.PageRight.IsAdd) {
        this.processExcelFile(file);
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
      event.target.value = '';
    }
  }

  processExcelFile(file: File): void {
    //if (this.Datas.length > 0) {
    if (true || moment(this.dateFormate.format(this.filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.filter.FromDateObj), 'DD MMM YYYY'))) {
      if (true || this.filter.FromDateObj.month == this.filter.ToDateObj.month && this.filter.FromDateObj.year == this.filter.ToDateObj.year) {
        if (true || this.filter.BranchId != null && this.filter.BranchId != ''
          && this.filter.ClientId != null && this.filter.ClientId != ''
          && this.filter.SiteId != null && this.filter.SiteId != ''
        ) {
          this.isDisabled = true;
          try {
            const reader = new FileReader();
            reader.onload = (event) => {
              if (event && event.target && event.target.result) {
                const binaryString = event.target.result as string;
                const workbook = XLSX.read(binaryString, { type: 'binary' });
                const sheetName = 'Sheet1';
                if (!workbook.SheetNames.includes(sheetName)) {
                  const errorMessage = 'Sheet1 not found in the uploaded file.';
                  this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
                  this.isDisabled = false;
                  return;
                }
                const worksheet = workbook.Sheets[sheetName];
                const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
                const headerRow = excelData[0];
                const headers = headerRow.map((header: string) => header.trim());
                const dataRows = excelData.slice(1);

                for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
                  const row = dataRows[rowIndex];
                  const rowData: any = {};

                  row.forEach((cellData, index) => {
                    rowData[headers[index]] = cellData;
                  });

                  if (Object.keys(rowData).length > 0) {
                    if (this.filter.MonthYear == null || this.filter.MonthYear == '') {
                      this.filter.MonthYear = rowData['MonthYear'] ?? ''
                    }
                    this.ExcelDatas.push({
                      EmpCode: rowData['EmpCode'] ?? '',
                      BranchName: rowData['BranchCode'] ?? '',
                      SiteCode: rowData['SiteCode'] ?? '',
                      D1: rowData['D1'] ?? '',
                      D2: rowData['D2'] ?? '',
                      D3: rowData['D3'] ?? '',
                      D4: rowData['D4'] ?? '',
                      D5: rowData['D5'] ?? '',
                      D6: rowData['D6'] ?? '',
                      D7: rowData['D7'] ?? '',
                      D8: rowData['D8'] ?? '',
                      D9: rowData['D9'] ?? '',
                      D10: rowData['D10'] ?? '',
                      D11: rowData['D11'] ?? '',
                      D12: rowData['D12'] ?? '',
                      D13: rowData['D13'] ?? '',
                      D14: rowData['D14'] ?? '',
                      D15: rowData['D15'] ?? '',
                      D16: rowData['D16'] ?? '',
                      D17: rowData['D17'] ?? '',
                      D18: rowData['D18'] ?? '',
                      D19: rowData['D19'] ?? '',
                      D20: rowData['D20'] ?? '',
                      D21: rowData['D21'] ?? '',
                      D22: rowData['D22'] ?? '',
                      D23: rowData['D23'] ?? '',
                      D24: rowData['D24'] ?? '',
                      D25: rowData['D25'] ?? '',
                      D26: rowData['D26'] ?? '',
                      D27: rowData['D27'] ?? '',
                      D28: rowData['D28'] ?? '',
                      D29: rowData['D29'] ?? '',
                      D30: rowData['D30'] ?? '',
                      D31: rowData['D31'] ?? '',
                    })
                  }


                  // const excelIndex = this.Datas.findIndex((e: any) => e.EmpMasterID == rowData['EmpMasterID']);
                  // if (excelIndex >= 0) {
                  //   if (this.Datas[excelIndex].ShiftCode != '' && this.Datas[excelIndex].ShiftCode != null) {
                  //     this.DisplayColumns.forEach((element: any) => {
                  //       if (rowData[element] != undefined) {
                  //         if (rowData[element].toString().trim() != '' && rowData[element].toString().trim() != null && rowData[element].toString().trim() != undefined
                  //           && (this.Datas[excelIndex].ShiftCode.split(',').findIndex((e: any) => this.common.ToLowerCase(e) == this.common.ToLowerCase(rowData[element].toString().trim())) >= 0)) {
                  //           this.Datas[excelIndex][element] = this.Datas[excelIndex].ShiftCode.split(',')[this.Datas[excelIndex].ShiftCode.split(',').findIndex((e: any) => this.common.ToLowerCase(e) == this.common.ToLowerCase(rowData[element].toString().trim()))];
                  //           this.setflag(excelIndex);
                  //         }
                  //       }
                  //     });
                  //   }
                  // }
                }

                if (this.ExcelDatas.length > 0) {
                  this.ESS_EmpRoster_ExcelUpload();
                }
                // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                //   dtInstance.destroy();
                //   this.dtTrigger.next(null);
                // });
                this.isDisabled = false;
              } else {
                console.error('Failed to read the file.');
                this.isDisabled = false;
              }
            };
            reader.readAsBinaryString(file);
          } catch (e) {
            this.isDisabled = false;
          }
        } else {
          this.toast.show({ message: 'Please select brach | client | site', type: toastTypeEnum.danger });
        }
      } else {
        this.toast.show({ message: 'Please select from date to date in single month year', type: toastTypeEnum.danger });
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
    // } else {
    //   this.toast.show({ message: 'Data not available in grid', type: toastTypeEnum.warning })
    // }
  }

  ESS_EmpRoster_ExcelUpload() {
    if (this.common.PageRight.IsAdd) {
      if (this.ExcelDatas.length > 0) {
        const modalRef = this.modalService.open(ConfirmationComponent);
        modalRef.componentInstance.Message = 'Do you want to save?';
        modalRef.result.then(result => {
          if (result) {
            this.isDisabled = true;
            this.shiftRoster.ESS_EmpRoster_ExcelUpload({ 'SelectType': this.filter.EmpType == 'front' ? 'F' : 'B', 'MonthYear': this.filter.MonthYear, 'ESS_EmpRosterMaster_EU': this.ExcelDatas }).subscribe({
              next: (response) => {
                if (response.Table.length > 0) {
                  this.download.exportToExcel(response.Table, "ShifRoster_Result");
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = "Response file downloaded";
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.ClearData();
                    }
                  });
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = "Something went wrong";
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        });
      } else {
        this.toast.show({ message: 'No Data for save', type: toastTypeEnum.warning });
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  ClearData() {
    this.Datas = [];
    this.ExcelDatas = [];
    this.DisplayColumns = [];
  }

  getColDate(i: any) {
    return moment(this.dateFormate.format(this.filter.FromDateObj), 'DD MMM YYYY').add(i, 'days').format("DD/MMM (ddd)");
  }

  onEmpTypeChange(type: string) {
    if (type === 'Front') {
      this.ClearData();
    } else if (type === 'Back') {
      this.ClearData();
    }
  }

  setflag(index: number) {
    if (index >= 0) {
      this.Datas[index].IsModified = true;
    }
  }
} 
